import React, { useMemo } from 'react'
import { isTV } from '../../helpers/screen'

function ScreenType({ children, type = 'default' }) {
  const isTVScreen = useMemo(() => {
    return isTV()
  }, [])

  return (
    <>
      {isTVScreen && type === 'tv' ? children : null}
      {!isTVScreen && type === 'default' ? children : null}
    </>
  )
}

export default ScreenType
